import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import propTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import { validateHex } from './SelectPrimaryColor';
import { StyledButton } from '../../../Components/Generics.styled';

const SelectSecondaryColorContainer = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
`;

const Title = styled.div`
    font-size: 23px;
    font-weight: bold;
    margin-top: 80px;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    margin-bottom: 50px;
`;

const DropdownApplet = styled.div`
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    width: 500px;
    height: 100px;
    text-align: center;

    .MuiSelect-outlined.MuiSelect-outlined {
        background-color: #fafbf7;
    }
`;

const StyledNavButtons = styled.div`
    margin-top: 30px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;

const ColorPickerApplet = styled.div`
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    /* width: 500px; */
    height: 100px;
    text-align: center;
`;

const ColorPicker = styled.input`
    height: 50px;
    width: 400px;
    padding: 0px;
    border-width: 0px;
    border-color: #fafbf7;
    background-color: #fafbf7;
    cursor: pointer;
`;

const SelectSecondaryColor = (props) => {
    const { handleNavButtonBack, handleNavButtonNext, leadGenerationData, setLeadGenerationData } =
        props;

    const handleChangeColor = (hexValue) => {
        setLeadGenerationData({
            ...leadGenerationData,
            theme: { ...leadGenerationData.theme, secondaryColor: hexValue },
        });
    };

    return (
        <SelectSecondaryColorContainer>
            <Title>Select a Button Text Color</Title>
            <ColorPickerApplet>
                <ColorPicker
                    type="color"
                    value={leadGenerationData.theme.secondaryColor}
                    onChange={(e) => handleChangeColor(e.target.value)}
                />
            </ColorPickerApplet>
            <TextField
                value={leadGenerationData.theme.secondaryColor}
                variant="outlined"
                placeholder="Hex value"
                style={{
                    width: 150,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginBottom: '30px',
                }}
                onChange={(e) => handleChangeColor(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Backspace') {
                        handleChangeColor(e.target.value);
                    }
                }}
            />
            <StyledNavButtons>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonBack()}
                >
                    Back
                </StyledButton>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonNext()}
                    disabled={!validateHex(leadGenerationData.theme.secondaryColor)}
                >
                    Next
                </StyledButton>
            </StyledNavButtons>
        </SelectSecondaryColorContainer>
    );
};

SelectSecondaryColor.propTypes = {
    handleNavButtonNext: propTypes.func,
    handleNavButtonBack: propTypes.func,
    leadGenerationData: propTypes.shape({
        theme: propTypes.shape({ secondaryColor: propTypes.string }),
    }),
    setLeadGenerationData: propTypes.func,
};

SelectSecondaryColor.defaultProps = {
    handleNavButtonNext: () => {},
    handleNavButtonBack: () => {},
    leadGenerationData: {},
    setLeadGenerationData: () => {},
};
export default SelectSecondaryColor;
